import React from "react";
import { Layout } from "antd";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { FooterInmersys } from "../components/Footer/FooterInmersys";
import { useVerificateToken } from "../hooks/useVerificateToken";
import { ErrorServer } from "../components/Errors/ErrorServer";

const { Header, Content, Footer } = Layout;

export const LayoutHome = () => {
    const state = useSelector((state) => state.ui.errorServer);
    useVerificateToken();


    return (
        <Layout className="layout layout-full">
            <Header>
                <span style={{ color: "white" }}>Inmersys</span>
            </Header>
            <Content>{state ? <ErrorServer /> : <Outlet />}</Content>
            <Footer>
                <FooterInmersys />
            </Footer>
        </Layout>
    );
};
